import client from './api-client';

export const getCargasPrevias = async(query) => {
    try {
        
        const response = await client.get(`movimientos-actualizados-cia/historial-cargas?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cargas_previas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getIngresoPagos = async(query) => {
    try {
        
        const response = await client.get(`movimientos-actualizados-cia/movimientos-xls?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                ingresoPagos: response.data
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}


export const postCargarArchivo = async(file) => {
    try {
        
        const response = await client.post('movimientos-actualizados-cia/carga-archivo', file);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.message;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboTipoMovimientos= async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoMovimiento: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}